module.exports = __webpack_public_path__ + "static/media/20240319084901_IMG_6021-min.ee73b4d5.JPG";